import React, { useState } from 'react';
import { markerCategories, getMarkerLabel, isMarkerHidden } from './markersDictionary';
import './MarkersFilter.scss';

const MarkersFilter = ({ selectedMarkers, setSelectedMarkers, sidebar = false }) => {
  const [open, setOpen] = useState(sidebar);

  // Выбрать/снять все маркеры категории
  const handleCategoryToggle = (category, checked) => {
    setSelectedMarkers(prev => {
      if (checked) {
        return Array.from(new Set([...prev, ...category.markers]));
      } else {
        return prev.filter(m => !category.markers.includes(m));
      }
    });
  };

  // Выбрать/снять отдельный маркер
  const handleMarkerToggle = (marker, checked) => {
    setSelectedMarkers(prev => {
      if (checked) {
        return [...prev, marker];
      } else {
        return prev.filter(m => m !== marker);
      }
    });
  };

  // Проверка: выбраны ли все маркеры категории
  const isCategoryChecked = (category) => {
    return category.markers.every(m => selectedMarkers.includes(m));
  };

  // Проверка: выбран ли хотя бы один маркер категории
  const isCategoryIndeterminate = (category) => {
    return category.markers.some(m => selectedMarkers.includes(m)) && !isCategoryChecked(category);
  };

  return (
    <div className={`markers-filter ${sidebar ? 'sidebar' : ''}`}>
      {!sidebar && (
        <button
          className="markers-filter-button"
          onClick={() => setOpen(o => !o)}
          type="button"
        >
          {selectedMarkers.length > 0 ? `Selected: ${selectedMarkers.length}` : 'Select markers'}
        </button>
      )}
      
      {sidebar && (
        <h3 style={{ width: '100%', margin: '0 0 4px 0', paddingBottom: '8px', fontSize: '18px', fontWeight: '600', color: '#1976d2', borderBottom: '1px solid #e0e0e0' }}>
          Фильтр маркеров
        </h3>
      )}
      
      <div className={`markers-dropdown ${open ? 'open' : ''}`}>
        {open && (
          <>
            {!sidebar && (
              <div className="dropdown-header">
                <button 
                  className="close-button" 
                  onClick={() => setOpen(false)}
                >
                  Close
                </button>
              </div>
            )}
            
            {markerCategories.map(category => (
              <div key={category.category} className="category-section">
                <label className="category-label">
                  <input
                    type="checkbox"
                    checked={isCategoryChecked(category)}
                    ref={el => { if (el) el.indeterminate = isCategoryIndeterminate(category); }}
                    onChange={e => handleCategoryToggle(category, e.target.checked)}
                    className="category-checkbox"
                  />
                  {category.category}
                </label>
                
                <div className="markers-list">
                  {category.markers.map(marker => (
                    isMarkerHidden(marker) ? null :
                    <label key={marker} className="marker-item">
                      <input
                        type="checkbox"
                        checked={selectedMarkers.includes(marker)}
                        onChange={e => handleMarkerToggle(marker, e.target.checked)}
                        className="marker-checkbox"
                      />
                      {getMarkerLabel(marker)}
                    </label>
                  ))}
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default MarkersFilter; 